/* Script copied from https://codepen.io/brenden/pen/Kwbpyj */
$('.toggle_owc').click(function(e) {
    e.preventDefault();  
    var $this = $(this);
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp('fast');
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp('fast');
        $this.next().toggleClass('show');
        $this.next().slideToggle('fast');
    }
});